import LinkedList from '../utils/linkedList';
import Utils from '../utils/util';

function linkContain(parent: LinkedListInstance, child: LinkedListInstance): boolean {
    let headPos: number = parent.indexOf(child.head.val);

    if (headPos === -1) {
        return false;
    }

    if (parent.length < child.length) {
        return false;
    }

    let parentNode: LinkedNodeInstance = parent.getElementAt(headPos);
    let headNode: LinkedNodeInstance = child.head;

    while (headNode) {
        if (parentNode === null) {
            return false;
        }

        if (headNode.val !== parentNode.val) {
            return false;
        }
        parentNode = parentNode.next;
        headNode = headNode.next;
    }

    return true;
}

// child 的头部是否与 parent 尾部链接
function lastLinkHead(parent: LinkedListInstance, child: LinkedListInstance): boolean {
    let headPos: number = parent.indexOf(child.head.val);

    if (headPos === -1) {
        return false;
    }

    let parentNode: LinkedNodeInstance = parent.getElementAt(headPos);
    let headNode: LinkedNodeInstance = child.head;

    while (parentNode) {
        if (headNode === null) {
            return false;
        }

        if (headNode.val !== parentNode.val) {
            return false;
        }
        parentNode = parentNode.next;
        headNode = headNode.next;
    }

    return true;
}

function linkEqual(list1: LinkedListInstance, list2: LinkedListInstance): boolean {
    if (list1.length !== list2.length) {
        return false;
    }

    if (list1.length === 0) {
        return true;
    }

    let list1Head: LinkedNodeInstance = list1.head;
    let list2Head: LinkedNodeInstance = list2.head;

    while (list1Head) {
        if (list1Head.val !== list2Head.val) {
            return false;
        }
        list1Head = list1Head.next;
        list2Head = list2Head.next;
    }

    return true;
}

function linkCanMerge(list1: LinkedListInstance, list2: LinkedListInstance): boolean {
    return linkContain(list1, list2)
        || linkContain(list2, list1)
        || lastLinkHead(list1, list2)
        || lastLinkHead(list2, list1)
}

function linkMerge(list1: LinkedListInstance, list2: LinkedListInstance): LinkedListInstance {
    if (linkContain(list1, list2)) {
        return list1;
    }

    if (linkContain(list2, list1)) {
        return list2;
    }

    if (lastLinkHead(list1, list2)) {
        return lastConnectHead(list1, list2);
    }

    if (lastLinkHead(list2, list1)) {
        return lastConnectHead(list2, list1);
    }
}

function linkGroupAdd(linkList: LinkedListInstance[], newLink: LinkedListInstance): void {
    if (linkList.length === 0) {
        linkList.push(newLink);
        return;
    }

    for (let i = 0; i < linkList.length; i++) {
        if (!linkCanMerge(linkList[i], newLink)) {
            if (i === linkList.length - 1) {
                linkList.push(newLink);
                break;
            }
            continue;
        }
        let merge: LinkedListInstance = linkMerge(linkList[i], newLink);

        linkList.splice(i, 1);
        linkGroupAdd(linkList, merge);
        break;
    }
}

function lastConnectHead(list1: LinkedListInstance, list2: LinkedListInstance): LinkedListInstance {
    let lastNode: LinkedNodeInstance = list1.getElementAt(list1.length - 1);
    let index: number = list2.indexOf(lastNode.val);
    let linkNode: LinkedNodeInstance = list2.getElementAt(index).next;

    lastNode.next = linkNode;
    linkNode.prev = lastNode;
    list1.length += list2.length - (index + 1);
    return list1;
}

// 链表打散
function linkSplit(link: LinkedListInstance, splitValues: any[], direction: string = 'both'): LinkedListInstance[] {
    let result: LinkedListInstance[] = [];
    let splitValuesList: Set<any> = new Set(splitValues);
    let newList: LinkedListInstance = new LinkedList();
    let splitValuesCopy: any[] = [];

    link.walk((val: any, index: number): void => {
        if (splitValuesList.has(val)) {
            splitValuesCopy.push(val);
        }
    });
    let splitValue: any = splitValuesCopy.shift();

    link.walk((val: any, index: number): void => {
        if (val === splitValue && direction === 'right') {
            newList.length === 0 && result.push(newList);
            newList.append(val);
            splitValue = splitValuesCopy.shift();
            newList = new LinkedList();
            return;
        }

        if (val === splitValue && direction === 'left') {
            splitValue = splitValuesCopy.shift();
            newList = new LinkedList();
            newList.append(val);
            result.push(newList);
            return;
        }

        if (val === splitValue && direction === 'both') {
            splitValue = splitValuesCopy.shift();
            newList = new LinkedList();
            return;
        }

        if (newList.length === 0) {
            result.push(newList);
        }

        newList.append(val);
    });

    return result;
}

// 链表切割为两段, 从第 cutIndex 个 listNode 之后切
function linkCutToTwoPicese(link: LinkedListInstance, cutIndex: number): LinkedListInstance[] {
    let result: LinkedListInstance[] = [];
    let newList: LinkedListInstance = new LinkedList();

    link.walk((val: any, index: number): void => {
        if (index === cutIndex + 1) {
            newList = new LinkedList();
        }

        if (newList.length === 0) {
            result.push(newList);
        }

        newList.append(val);
    });

    return result;
}

export {
    linkContain,
    lastLinkHead,
    linkCanMerge,
    linkEqual,
    linkMerge,
    linkGroupAdd,
    linkSplit,
    linkCutToTwoPicese
};
